import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: undefined, // Auto-detect language
    fallbackLng: 'en',
    supportedLngs: ['tr', 'en', 'de', 'ar', 'ms'],

    // Use HTTP backend for dynamic loading
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'], // localStorage öncelikli: kullanıcının seçimi tarayıcı dilinden üstündür
      caches: ['localStorage'], // i18n.changeLanguage() çağrıldığında otomatik localStorage'a kaydeder
      lookupLocalStorage: 'i18nextLng',
      excludeCacheFor: ['cimode'],
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
    
    debug: false,
    
    // Add keySeparator and nsSeparator for better key handling
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n; 